enum webFunction {
    manageProject = 1, //จัดการโครงการ
    manageExternalResearcher = 2, //จัดการข้อมูลนักวิจัยภายนอก
    manageCertificateAndStamp = 3, //จัดการใบรับรองและตราสำนักงาน
    manageREC = 4, //จัดการราายชื่อกลุ่มสหสถาบัน
    manageProjectSubmittedType = 5, //จัดการเอกสารยื่นโครงการแต่ละประเภท
    manageFaculty = 6, //จัดการคณะ / สำนักงาน / วิทยาลัยที่เกี่ยวข้องกับโครงการ
    manageEditResultOfConsideration = 7, //จัดการแก้ไขชื่อผลการพิจารณา
    manageUser = 8, //รายชื่อผู้ใช้งานระบบ
    dashboard = 9, //แดชบอร์ด
    manageExternalProject = 10, //จัดการโครงการนอกระบบก่อนปี 2565
    manageExpertises = 11, //จัดการความเชี่ยวชาญ
    manageCommittees = 12, //รายชื่อกรรมการ
    manageCheckList = 13, //จัดการรายการแบบฟอร์มความเห็นพิจารณาโครงการ(Checklist)
    manageResearcher = 14, //จัดการข้อมูลนักวิจัย
    manageDocument = 15, //เอกสารดาวน์โหลด
    manageHoliday = 16, //จัดการวันหยุดนักขัตฤกษ์
    manageSystem = 17, //ตั้งค่าระบบ
    manageAgendas = 18, //ตั้งค่าวาะการประชุม
    preference = 99, //โปรไฟล์
}
export default webFunction
